import Vue from 'vue'
import VueAxios from 'vue-axios'

import SignalRClient from './core/SignalRClient'
import Utils from './core/Utils'
import axiosInterceptor from './core/axiosInterceptor'
import EventBus from './core/EventBus'
import Auth from './core/Auth'
import moment from 'moment'

// 组件
import TwIcon from './Icon/index.vue'
import TwUpload from './upload/index.vue'
import TwExport from './export/index.vue'
import TwTable from './table/index.vue'
import TwContainer from './layout/index.vue'
import TwItem from './layout/TwItem.vue'
import TwWindow from './window/index.vue'
import TwFileManager from './fileManager/index.vue'
import elDragDialog from '@/directive/el-dragDialog'
import SelectTree from './selectTree/index.vue'
import RightPanel from './rightpanel/index.vue'

// 框架样式
import '@/assets/styles/index.scss'


Vue.use(VueAxios, axiosInterceptor)

const components = {
  'tw-icon': TwIcon,
  'tw-export': TwExport,
  'tw-upload': TwUpload,
  'tw-table': TwTable,
  'tw-container': TwContainer,
  'tw-item': TwItem,
  'tw-window': TwWindow,
  'tw-fileManager': TwFileManager,
  'select-tree': SelectTree,
  'right-panel': RightPanel
}

export {
  TwIcon,
  TwTable,
  TwExport,
  TwUpload,
  TwWindow,
  TwFileManager,
  SelectTree,
  RightPanel
}



const Twinkle = {} as any;

// tslint:disable-next-line:only-arrow-functions
Twinkle.install = function(Vue): void {

  if (Twinkle.installed) {
    return;
  }
  Twinkle.installed = true;

  elDragDialog.install(Vue);

  // 安装自定义组件
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key])
  })

  // signalr插件
  const signalr = new SignalRClient();
  // 工具插件
  const utils = new Utils();
  // 消息总线插件
  const eventBus = new EventBus();


  // tslint:disable-next-line:quotemark
  Object.defineProperties(Vue["prototype"], {
    $signalr: {
      get() {
        return signalr;
      }
    },
    $utils: {
      get() {
        return utils;
      }
    },
    $eventBus: {
      get() {
        return eventBus;
      }
    },
    $auth: {
      get() {
        return Auth;
      }
    },
    $moment: {
      get() {
        return moment;
      }
    }
  })

  // 处理日期转换
  Date.prototype.toString = function() {
    return moment(this).format('YYYY-MM-DD HH:mm:ss')
  }

  Date.prototype.toDateString = function() {
    return moment(this).format('YYYY-MM-DD')
  }

  Date.prototype.toJSON = function() {
    return moment(this).format('YYYY-MM-DD HH:mm:ss')
  }
}


if (typeof window !== 'undefined' && (window as any).Vue) {
  Twinkle.install((window as any).Vue)
}

export default Twinkle
